import { useQuery } from '@tanstack/react-query';
import { ItemsApi } from '@/lib/api/common/items';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const useItemAncestorsQuery = ({ itemId }: { itemId: number }) => {
  return useQuery({
    queryKey: commonQueryKeys.itemAncestors(itemId),
    queryFn: () => ItemsApi.getItemAncestors({ itemId }),
    enabled: !!itemId,
  });
};
